import { useRef, useState, useCallback } from "react";

// Bots that scrape and auto-fill forms give themselves away in two ways:
// they populate every field they can find (including ones a human never sees),
// and they submit far faster than a person could have typed the form.
const MIN_FILL_TIME_MS = 3000;

export interface HoneypotProps {
  name: string;
  value: string;
  onChange: (e: { target: { value: string } }) => void;
}

export default function useSpamGuard(minFillTimeMs = MIN_FILL_TIME_MS) {
  const mountedAt = useRef(Date.now());
  const [honeypot, setHoneypot] = useState("");

  const honeypotProps: HoneypotProps = {
    name: "company_website",
    value: honeypot,
    onChange: (e) => setHoneypot(e.target.value),
  };

  const isLikelyBot = useCallback(() => {
    if (honeypot.trim()) return true;
    return Date.now() - mountedAt.current < minFillTimeMs;
  }, [honeypot, minFillTimeMs]);

  // Call after a successful submit so a reused form keeps its timing check honest.
  const resetSpamGuard = useCallback(() => {
    mountedAt.current = Date.now();
    setHoneypot("");
  }, []);

  return { honeypotProps, isLikelyBot, resetSpamGuard };
}
